// src/helper/Countdown.js

// Countdown Timer Function
function countdown() {
  const now = new Date();
  const nextMidnight = new Date(now);
  nextMidnight.setHours(24, 0, 0, 0); // Set to next midnight

  const timeLeft = nextMidnight.getTime() - now.getTime();

  if (timeLeft > 0) {
    // Calculate time components
    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    return { days: 0, hours, minutes, seconds };
  } else {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
}

// Export the function to get the current countdown
export function getCountdown() {
  return countdown();
}
